(() => {
  const availabilityParameter = 'filter.v.availability';
  const state = {
    key: null,
    container: null,
    grid: null,
    phase: 'idle',
    busy: false,
    scheduled: false
  };

  const getContainer = () => document.getElementById('ProductGridContainer');
  const getGrid = () => document.getElementById('product-grid');

  const getAvailabilityValues = () => {
    return new URL(window.location.href).searchParams.getAll(availabilityParameter);
  };

  const hasExplicitAvailability = () => getAvailabilityValues().length > 0;

  const getBaseUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete(availabilityParameter);
    return url;
  };

  const getSequenceKey = () => {
    const url = getBaseUrl();
    return url.pathname + '?' + url.searchParams.toString();
  };

  const getSectionUrl = (availability) => {
    const url = getBaseUrl();
    const sectionId = getGrid() && getGrid().dataset ? getGrid().dataset.id : '';
    if (!sectionId) return null;
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set(availabilityParameter, availability);
    return url;
  };

  const fetchSection = async (availability) => {
    const url = getSectionUrl(availability);
    if (!url) throw new Error('Collection section unavailable');
    const response = await fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Collection request failed');
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  };

  const setBusy = (isBusy) => {
    const container = getContainer();
    if (!container) return;
    if (isBusy) container.style.minHeight = Math.min(container.getBoundingClientRect().height, window.innerHeight) + 'px';
    container.classList.toggle('lfe-stock-sequence--loading', isBusy);
    container.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  };

  const syncProductCounts = (sourceDocument) => {
    document.querySelectorAll('[id^="ProductCount"]').forEach((current) => {
      const replacement = sourceDocument.getElementById(current.id);
      if (replacement) current.innerHTML = replacement.innerHTML;
    });
  };

  const updateArchiveSwitch = () => {
    const archiveSwitch = document.querySelector('[data-lfe-archive-switch]');
    if (!archiveSwitch) return;

    const values = getAvailabilityValues();
    const archiveActive = values.length === 1 && values[0] === '0';
    const baseUrl = getBaseUrl();
    const targetUrl = new URL(baseUrl.toString());
    const setText = (selector, value) => {
      const element = archiveSwitch.querySelector(selector);
      if (element && element.textContent !== value) element.textContent = value;
    };

    if (archiveActive) {
      archiveSwitch.classList.add('is-archive');
      setText('[data-lfe-archive-kicker]', 'Archives de la Maison');
      setText('[data-lfe-archive-message]', 'Ces pièces vendues restent visibles comme références.');
      setText('[data-lfe-archive-label]', 'Voir les pièces disponibles');
    } else {
      targetUrl.searchParams.set(availabilityParameter, '0');
      archiveSwitch.classList.remove('is-archive');
      setText('[data-lfe-archive-kicker]', 'Une collection vivante');
      setText('[data-lfe-archive-message]', 'Les pièces vendues restent consultables dans les archives de cette sélection.');
      setText('[data-lfe-archive-label]', 'Voir les pièces vendues');
    }

    const link = archiveSwitch.querySelector('[data-lfe-archive-link]');
    link.href = archiveActive ? baseUrl.toString() : targetUrl.toString();
  };

  const startAvailablePhase = async () => {
    if (state.busy || hasExplicitAvailability()) return;

    const expectedKey = getSequenceKey();
    if (state.key === expectedKey && state.phase === 'available' && state.container === getContainer() && state.grid === getGrid()) return;

    state.key = expectedKey;
    state.phase = 'loading-available';
    state.busy = true;
    setBusy(true);

    try {
      const documentFromAvailable = await fetchSection('1');
      if (hasExplicitAvailability() || getSequenceKey() !== expectedKey) return;

      const currentContainer = getContainer();
      const availableContainer = documentFromAvailable.getElementById('ProductGridContainer');
      if (!currentContainer || !availableContainer) {
        throw new Error('Available collection grid unavailable');
      }

      currentContainer.innerHTML = availableContainer.innerHTML;
      state.container = currentContainer;
      state.grid = getGrid();
      syncProductCounts(documentFromAvailable);
      state.phase = 'available';
    } catch (error) {
      console.error('[LFE collection availability]', error);
      state.phase = 'fallback';
    } finally {
      state.busy = false;
      setBusy(false);
    }

    updateArchiveSwitch();
  };

  const inspect = () => {
    if (!getContainer() || !getGrid()) return;

    updateArchiveSwitch();

    if (hasExplicitAvailability()) {
      state.key = null;
      state.phase = 'native';
      state.busy = false;
      setBusy(false);
      return;
    }

    const currentKey = getSequenceKey();
    if (state.key !== currentKey || state.container !== getContainer() || state.grid !== getGrid() || ['idle', 'native', 'fallback'].includes(state.phase)) {
      startAvailablePhase();
    }
  };

  const scheduleInspect = () => {
    if (state.scheduled) return;
    state.scheduled = true;
    window.setTimeout(() => {
      state.scheduled = false;
      inspect();
    }, 0);
  };

  const initialize = () => {
    if (!window.location.pathname.includes('/collections/')) return;
    if (!document.querySelector('[name="filter.v.availability"]')) return;

    const parent = document.getElementById('MainContent');
    if (!parent || !getContainer() || !getGrid()) return;

    new MutationObserver(scheduleInspect).observe(parent, {
      childList: true,
      subtree: true
    });

    window.addEventListener('popstate', scheduleInspect);
    inspect();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
